function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M263.595,190.15l32.644-32.644c4.115,0.801,8.306,1.208,12.51,1.208c0.001,0,0.001,0,0.002,0 c17.396,0,33.75-6.772,46.047-19.069c16.384-16.384,22.843-40.493,16.859-62.918l-1.133-4.248l-4.248-1.133 c-5.495-1.466-11.171-2.21-16.87-2.21c-17.398,0-33.752,6.772-46.049,19.069c-15.326,15.326-21.966,37.414-17.86,58.559 l-21.901,21.901V112.65c17.855-12.049,28.778-32.362,28.778-54.036c0-23.17-12.479-44.786-32.569-56.411L256,0l-3.805,2.202 c-20.089,11.626-32.569,33.241-32.569,56.411c0,21.674,10.923,41.987,28.778,54.036v111.615l-21.96-21.96 c4.106-21.146-2.534-43.233-17.86-58.559c-12.297-12.297-28.65-19.069-46.049-19.069c-5.699,0-11.374,0.743-16.87,2.21l-4.248,1.133 l-1.133,4.248c-5.984,22.427,0.476,46.536,16.859,62.918c12.296,12.296,28.65,19.068,46.049,19.069c0.001,0,0.001,0,0.001,0 c4.203,0,8.394-0.408,12.51-1.208l32.702,32.702v29.737H98.786v69.835h14.464l18.81,166.679h247.878l18.81-166.679h14.464v-69.835 H263.595V190.15z M314.099,98.947c9.428-9.428,21.966-14.619,35.307-14.619c2.865,0,5.723,0.245,8.539,0.729 c2.727,15.894-2.395,32.353-13.888,43.847c-9.428,9.428-21.967,14.62-35.306,14.619c-2.866,0-5.723-0.245-8.539-0.729 C297.483,126.899,302.606,110.441,314.099,98.947z M211.73,198.335c-2.816,0.485-5.673,0.729-8.538,0.729h-0.001 c-13.341,0-25.88-5.192-35.307-14.619c-11.494-11.494-16.617-27.952-13.888-43.847c2.816-0.485,5.674-0.729,8.539-0.729 c13.34,0,25.879,5.191,35.307,14.619C209.335,165.983,214.459,182.439,211.73,198.335z M234.817,58.614 c0-16.255,8.015-31.514,21.182-40.825c13.167,9.309,21.182,24.57,21.182,40.825c0,16.254-8.015,31.514-21.182,40.824 C242.832,90.127,234.817,74.868,234.817,58.614z M366.365,496.808H145.634l-17.096-151.487h254.922L366.365,496.808z  M398.021,290.678v39.451H113.978v-39.451H398.021z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgPlant = function SvgPlant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "373.152,504.404 138.847,504.404 120.037,337.726 391.962,337.726 "
  }), React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "255.048,337.726 120.037,337.726 138.847,504.404 255.048,504.404 "
  }), React.createElement("rect", {
    x: 106.381,
    y: 283.079,
    style: {
      fill: "#000"
    },
    width: 299.233,
    height: 54.643
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M284.777,58.614c0-21.301-11.58-39.884-28.778-49.837c-17.199,9.954-28.778,28.537-28.778,49.837 s11.58,39.884,28.778,49.837C273.198,98.498,284.777,79.914,284.777,58.614z"
  }), React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M349.427,134.275c15.062-15.062,20.014-36.39,14.891-55.589 c-19.199-5.124-40.528-0.17-55.589,14.891c-15.062,15.062-20.014,36.39-14.891,55.589 C313.037,154.288,334.366,149.336,349.427,134.275z"
  }), React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M203.212,149.117c-15.062-15.062-36.39-20.014-55.589-14.891 c-5.124,19.199-0.17,40.528,14.891,55.589c15.061,15.061,36.39,20.014,55.589,14.891 C223.226,185.507,218.274,164.179,203.212,149.117z"
  })), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M256,8.777c-17.199,9.954-28.778,28.537-28.778,49.837s11.58,39.884,28.778,49.837 C255.644,107.982,256.103,8.893,256,8.777z"
  }), React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M364.318,78.685c-19.199-5.124-40.528-0.17-55.589,14.891 c-15.062,15.062-20.014,36.39-14.891,55.589C293.72,149.268,364.367,79.539,364.318,78.685z"
  }), React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M147.623,134.227c-5.124,19.199-0.17,40.528,14.891,55.589 c15.061,15.061,36.39,20.014,55.589,14.891c-0.642,0.341-29.617-29.052-50.213-49.983 C156.621,143.273,147.862,134.354,147.623,134.227z"
  })), _ref2, React.createElement("g", null, React.createElement("rect", {
    x: 239.125,
    y: 472.214,
    style: {
      fill: "#FFFFFF"
    },
    width: 86.177,
    height: 15.192
  }), React.createElement("rect", {
    x: 335.287,
    y: 472.214,
    style: {
      fill: "#FFFFFF"
    },
    width: 23.876,
    height: 15.192
  }), React.createElement("rect", {
    x: 145.504,
    y: 355.148,
    style: {
      fill: "#FFFFFF"
    },
    width: 64.108,
    height: 15.192
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plant.84fb6838.svg";
export { ForwardRef as ReactComponent };